export enum ExtractionStateEnum {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Error = 'Error',
}
